import { Component } from '@angular/core';

@Component({
  selector: 'app-performance-values',
  templateUrl: './performance-values.component.html',
  styleUrls: ['./performance-values.component.css'],
})
export class PerformanceValuesComponent {
  constructor() {}

  params: any = {};
  ngOnInit(): void {
    const params = new URLSearchParams(window.location.search);
    params.forEach((value, key) => {
      this.params[key] = value;
    });
  }
}
